module.exports = __webpack_public_path__ + "static/media/favicon.9ef1d7ee.ico";